import React, { useRef } from 'react'
import CanvasLines from './CanvasLines'

type Props = {}

const LessonSlideCanvas = (props: Props) => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null)
  return (
    <div className="w-full h-full absolute top-0 left-0 pointer-events-none">
      <canvas className="w-full h-full" ref={canvasRef} />
      <CanvasLines canvasRef={canvasRef} />
    </div>
  )
}

export default LessonSlideCanvas
